import { reactive } from 'vue';

import type { BalanceModel } from '@exchange/libs/balances/service/src';
import { logger } from '@exchange/libs/utils/simple-logger/src';

import { CURRENCY_ELIGIBLE_FOR_MARGIN } from './constants.config';

interface SubaccountMarginBalance {
  available: number;
  used: number;
}

interface SubaccountMarginState {
  balances: KeyMap<SubaccountMarginBalance>;
}

const getDefaultState = () => ({
  balances: {},
});

const getDefaultMarginBalance = (): SubaccountMarginBalance => ({
  available: 0,
  used: 0,
});

class SubaccountMarginService {
  private readonly logPrefix = 'SubaccountMarginService:';

  private readonly state = reactive<SubaccountMarginState>(getDefaultState());

  public getAccountBalance(subaccountId: string) {
    return this.state.balances[subaccountId];
  }

  public updateStateFromBalances(balances: KeyMap<BalanceModel[]>) {
    logger.info(`${this.logPrefix} Updating subaccount balances from balances`, balances);

    // eslint-disable-next-line no-restricted-syntax
    for (const [subaccountId, balance] of Object.entries(balances)) {
      const marginBalance = getDefaultMarginBalance();
      const marginCurrencyBalance = balance.find((b) => b.currencyCode === CURRENCY_ELIGIBLE_FOR_MARGIN);

      if (marginCurrencyBalance) {
        Object.assign(marginBalance, {
          available: Math.max(marginCurrencyBalance.marginAvailable?.toNumber() ?? marginCurrencyBalance.available.toNumber(), 0),
          used: marginCurrencyBalance.marginUsed?.toNumber() ?? 0,
        });
      }

      this.state.balances[subaccountId] = marginBalance;
    }
  }

  public reset() {
    Object.assign(this.state, getDefaultState());
  }
}

const subaccountMarginService = new SubaccountMarginService();

export default subaccountMarginService;
